import { FC, ReactChild } from 'react';
import classNames from 'classnames';
import { Rewind } from '../Rewind';
import { Section } from '../Section';
import { PGN } from '../PGN';
import { useAction, useAtom } from '@reatom/npm-react';
import {
  analyzeGameAction,
  analysisProgressAtom,
  getAnalysisGameAction,
  rewindAction,
  selectedMoveAtom,
  selectMoveAction,
} from '../../model';
import { GameScore } from '../GameScore';
import { buttonsStyles } from './styles.css';
import { MoveFeedback } from '../MoveFeedback';
import { contentPaddingStyles } from '../../styles.css';
import { Progress } from '../Progress';
import { FooterButtons } from '../FooterButtons';

type Props = {
  className: string;
  analyzeButton?: ReactChild;
};

const AnalysisTab: FC<Props> = ({ className, analyzeButton }) => {
  const [game] = useAtom(getAnalysisGameAction.dataAtom);
  const [analyzingStatus] = useAtom(analyzeGameAction.statusesAtom);
  const [analyzeGameController] = useAtom(analyzeGameAction.abortControllerAtom);
  const [analysisProgress] = useAtom(analysisProgressAtom);
  const [selectedMove] = useAtom(selectedMoveAtom);
  const selectMove = useAction(selectMoveAction);
  const rewind = useAction(rewindAction);

  const analyzing = analyzingStatus.isPending && !analyzeGameController?.signal.aborted;

  return (
    <article className={className} aria-label="analysis">
      {selectedMove && <MoveFeedback move={selectedMove} />}

      <Section className="scrollStyle">
        <PGN moves={game?.moves} onClick={selectMove} selected={selectedMove} />
        <GameScore game={game} />
      </Section>

      {analyzeButton}

      {analyzing && <Progress value={analysisProgress} />}

      <div className={classNames(contentPaddingStyles, buttonsStyles)}>
        <Rewind onRewind={rewind} />

        <FooterButtons />
      </div>
    </article>
  );
};

export default AnalysisTab;
